/**
 * @author Tomasz Czura (8/18/16)
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';

class ErrorBox extends Component {
  render() {
    const style = {};
    if (this.props.textSize) {
      style['fontSize'] = this.props.textSize;
    }
    if (this.props.textWeight) {
      style['fontWeight'] = this.props.textWeight;
    }

    style['color'] = '#FF6F00';

    return (
      <div>
        {this.props.errorMessage ? (
                    <div style={style}>{this.props.errorMessage}</div>
                ) : null}
      </div>
    );
  }
}

export function createBulletPointList(title, messages) {
  return (
    <div>
      <span>{title}</span>
      <ul>
        {messages.map((message, index) => (
          <li key={index}>{message}</li>
        ))}
      </ul>
    </div>
  );
}

export function createErrorMessage(errorResponse) {
  return (
    <div>
      <span>Response received from HAPI:<br/></span>
      <span>[<b>{errorResponse.errorSource}</b>] responded with status [<b>{errorResponse.errorCode}</b>]<br/></span>
      <span>With the message: [<b>{errorResponse.errorMessage}</b>]</span>
    </div>
  );
}

ErrorBox.propTypes = {
  errorMessage: PropTypes.string,
  textSize: PropTypes.string,
  textWeight: PropTypes.string,
};
ErrorBox.defaultProps = {};

export default ErrorBox;
